export default __webpack_public_path__ + "static/mikaellundin-d427aaad79cbb6b895eb00a47c73795c.webp";